module.exports = __webpack_public_path__ + "img/kufri-beige-icon.3ca7fa5.webp";